// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Abel&family=Roboto:ital,wght@0,300;0,400;0,500;0,700;0,900;1,400&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Abel&family=Inter:wght@200;300;400;500;600;700;800&family=Roboto:ital,wght@0,300;0,400;0,500;0,700;0,900;1,400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Margin Top*/
.mt-1 {
  margin-top: 0.25rem;
}

.mt-2 {
  margin-top: 0.5rem;
}

.mt-3 {
  margin-top: 0.75rem;
}

.mt-4 {
  margin-top: 1rem;
}

.mt-5 {
  margin-top: 1.25rem;
}

.mt-6 {
  margin-top: 1.5rem;
}

.mt-7 {
  margin-top: 1.75rem;
}

.mt-8 {
  margin-top: 2rem;
}

.mt-9 {
  margin-top: 2.25rem;
}

.mt-10 {
  margin-top: 2.5rem;
}

.mt-11 {
  margin-top: 2.75rem;
}

.mt-12 {
  margin-top: 3rem;
}

.mt-13 {
  margin-top: 3.25rem;
}

.mt-14 {
  margin-top: 3.5rem;
}

.mt-15 {
  margin-top: 3.75rem;
}

.mt-16 {
  margin-top: 4rem;
}

.mt-17 {
  margin-top: 4.25rem;
}

.mt-18 {
  margin-top: 4.5rem;
}

.mt-19 {
  margin-top: 4.75rem;
}

.mt-20 {
  margin-top: 5rem;
}

.mt-21 {
  margin-top: 5.25rem;
}

.mt-22 {
  margin-top: 5.5rem;
}

.mt-23 {
  margin-top: 5.75rem;
}

.mt-24 {
  margin-top: 6rem;
}

.mb-1 {
  margin-bottom: 0.25rem;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.mb-3 {
  margin-bottom: 0.75rem;
}

.mb-4 {
  margin-bottom: 1rem;
}

.mb-5 {
  margin-bottom: 1.25rem;
}

.mb-6 {
  margin-bottom: 1.5rem;
}

.mb-7 {
  margin-bottom: 1.75rem;
}

.mb-8 {
  margin-bottom: 2rem;
}

.mb-9 {
  margin-bottom: 2.25rem;
}

.mb-10 {
  margin-bottom: 2.5rem;
}

.mb-11 {
  margin-bottom: 2.75rem;
}

.mb-12 {
  margin-bottom: 3rem;
}

.mb-13 {
  margin-bottom: 3.25rem;
}

.mb-14 {
  margin-bottom: 3.5rem;
}

.mb-15 {
  margin-bottom: 3.75rem;
}

.mb-16 {
  margin-bottom: 4rem;
}

/*Margin Vertically*/
.my-1 {
  margin: 0.25rem 0;
}

.my-2 {
  margin: 0.5rem 0;
}

.my-3 {
  margin: 0.75rem 0;
}

.my-4 {
  margin: 1rem 0;
}

.my-5 {
  margin: 1.25rem 0;
}

.my-6 {
  margin: 1.5rem 0;
}

.my-7 {
  margin: 1.75rem 0;
}

.my-8 {
  margin: 2rem 0;
}

.my-9 {
  margin: 2.25rem 0;
}

.my-10 {
  margin: 2.5rem 0;
}

.my-11 {
  margin: 2.75rem 0;
}

.my-12 {
  margin: 3rem 0;
}

.my-13 {
  margin: 3.25rem 0;
}

.my-14 {
  margin: 3.5rem 0;
}

.my-15 {
  margin: 3.75rem 0;
}

.my-16 {
  margin: 4rem 0;
}

.my-17 {
  margin: 4.25rem 0;
}

.my-18 {
  margin: 4.5rem 0;
}

.my-19 {
  margin: 4.75rem 0;
}

.my-20 {
  margin: 5rem 0;
}

.my-21 {
  margin: 5.25rem 0;
}

.my-22 {
  margin: 5.5rem 0;
}

.my-23 {
  margin: 5.75rem 0;
}

.my-24 {
  margin: 6rem 0;
}

/*Margin horizontally*/
.mx-1 {
  margin: 0 0.25rem;
}

.mx-2 {
  margin: 0 0.5rem;
}

.mx-3 {
  margin: 0 0.75rem;
}

.mx-4 {
  margin: 0 1rem;
}

.mx-5 {
  margin: 0 1.25rem;
}

.mx-6 {
  margin: 0 1.5rem;
}

.mx-7 {
  margin: 0 1.75rem;
}

.mx-8 {
  margin: 0 2rem;
}

.mx-9 {
  margin: 0 2.25rem;
}

.mx-10 {
  margin: 0 2.5rem;
}

.mx-11 {
  margin: 0 2.75rem;
}

.mx-12 {
  margin: 0 3rem;
}

.mx-13 {
  margin: 0 3.25rem;
}

.mx-14 {
  margin: 0 3.5rem;
}

.mx-15 {
  margin: 0 3.75rem;
}

.mx-16 {
  margin: 0 4rem;
}

.mx-17 {
  margin: 0 4.25rem;
}

.mx-18 {
  margin: 0 4.5rem;
}

.mx-19 {
  margin: 0 4.75rem;
}

.mx-20 {
  margin: 0 5rem;
}

.mx-21 {
  margin: 0 5.25rem;
}

.mx-22 {
  margin: 0 5.5rem;
}

.mx-23 {
  margin: 0 5.75rem;
}

.mx-24 {
  margin: 0 6rem;
}

/*Padding Vertically and Horizontally*/
.p-1 {
  padding: 0.25rem;
}

.p-2 {
  padding: 0.5rem;
}

.p-3 {
  padding: 0.75rem;
}

.p-4 {
  padding: 1rem !important;
}

.pad-4 {
  padding: 1rem;
}

.p-5 {
  padding: 1.25rem;
}

.p-6 {
  padding: 1.5rem;
}

.p-7 {
  padding: 1.75rem;
}

.p-8 {
  padding: 2rem;
}

.p-9 {
  padding: 2.25rem;
}

.p-10 {
  padding: 2.5rem;
}

.p-11 {
  padding: 2.75rem;
}

.p-12 {
  padding: 3rem;
}

.p-13 {
  padding: 3.25rem;
}

.p-14 {
  padding: 3.5rem;
}

.p-15 {
  padding: 3.75rem;
}

.p-16 {
  padding: 4rem;
}

.p-17 {
  padding: 4.25rem;
}

.p-18 {
  padding: 4.5rem;
}

.p-19 {
  padding: 4.75rem;
}

.p-20 {
  padding: 5rem;
}

.p-21 {
  padding: 5.25rem;
}

.p-22 {
  padding: 5.5rem;
}

.p-23 {
  padding: 5.75rem;
}

.p-24 {
  padding: 6rem;
}

/*Padding Vertically*/
.py-1 {
  padding: 0.25rem 0;
}

.py-2 {
  padding: 0.5rem 0;
}

.py-3 {
  padding: 0.75rem 0;
}

.py-4 {
  padding: 1rem 0;
}

.py-5 {
  padding: 1.25rem 0;
}

.py-6 {
  padding: 1.5rem 0;
}

.py-7 {
  padding: 1.75rem 0;
}

.py-8 {
  padding: 2rem 0;
}

.py-9 {
  padding: 2.25rem 0;
}

.py-10 {
  padding: 2.5rem 0;
}

.py-11 {
  padding: 2.75rem 0;
}

.py-12 {
  padding: 3rem 0;
}

.py-13 {
  padding: 3.25rem 0;
}

.py-14 {
  padding: 3.5rem 0;
}

.py-15 {
  padding: 3.75rem 0;
}

.py-16 {
  padding: 4rem 0;
}

.py-17 {
  padding: 4.25rem 0;
}

.py-18 {
  padding: 4.5rem 0;
}

.py-19 {
  padding: 4.75rem 0;
}

.py-20 {
  padding: 5rem 0;
}

.py-21 {
  padding: 5.25rem 0;
}

.py-22 {
  padding: 5.5rem 0;
}

.py-23 {
  padding: 5.75rem 0;
}

.py-24 {
  padding: 6rem 0;
}

/*Padding Horizontally*/
.px-1 {
  padding: 0 0.25rem;
}

.px-2 {
  padding: 0 0.5rem;
}

.px-3 {
  padding: 0 0.75rem !important;
}

.px-4 {
  padding: 0 1rem;
}

.px-5 {
  padding: 0 1.25rem;
}

.px-6 {
  padding: 0 1.5rem;
}

.px-7 {
  padding: 0 1.75rem;
}

.px-8 {
  padding: 0 2rem;
}

.px-9 {
  padding: 0 2.25rem;
}

.px-10 {
  padding: 0 2.5rem;
}

.px-11 {
  padding: 0 2.75rem;
}

.px-12 {
  padding: 0 3rem;
}

.px-13 {
  padding: 0 3.25rem;
}

.px-14 {
  padding: 0 3.5rem;
}

.px-15 {
  padding: 0 3.75rem;
}

.px-16 {
  padding: 0 4rem;
}

.px-17 {
  padding: 0 4.25rem;
}

.px-18 {
  padding: 0 4.5rem;
}

.px-19 {
  padding: 0 4.75rem;
}

.px-20 {
  padding: 0 5rem;
}

.px-21 {
  padding: 0 5.25rem;
}

.px-22 {
  padding: 0 5.5rem;
}

.px-23 {
  padding: 0 5.75rem;
}

.px-24 {
  padding: 0 6rem;
}

body {
  background-color: #F4F6FA !important;
  font-weight: 500 !important;
}

.ff-inter {
  font-family: "Inter", sans-serif;
}

.ff-abel {
  font-family: "Abel", sans-serif;
}

.ff-roboto {
  font-family: "Roboto", sans-serif;
}

a {
  color: #636A7D !important;
}

a:hover {
  text-decoration: none !important;
}

h3 {
  font-weight: normal;
}

select {
  background-repeat: no-repeat;
  background-position: 96%;
  appearance: none;
}

.fs-12 {
  font-size: 12px;
}

.fs-13 {
  font-size: 12px;
}

.fs-14 {
  font-size: 14px;
}

.fs-16 {
  font-size: 1rem;
}

.fs-64 {
  font-size: 4rem;
}

h4 {
  font-weight: normal !important;
}

.card-title {
  margin-bottom: 1rem !important;
}

label,
h4 {
  color: #636A7D;
}

label {
  font-size: 14px;
}

/* Gaps */
.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 0.75rem !important;
}

.gap-4 {
  gap: 1rem !important;
}

.gap-5 {
  gap: 1.25rem !important;
}

.gap-6 {
  gap: 1.5rem !important;
}

.gap-7 {
  gap: 1.75rem !important;
}

.gap-8 {
  gap: 2rem !important;
}

.gap-12 {
  gap: 3rem;
}

.gap-16 {
  gap: 4rem;
}

/* Border Radius */
.radius-0 {
  border-radius: 0rem;
}

.radius-1 {
  border-radius: 0.25rem;
}

.radius-2 {
  border-radius: 0.5rem;
}

.radius-3 {
  border-radius: 0.75rem;
}

.radius-4 {
  border-radius: 1rem;
}

.radius-5 {
  border-radius: 1.25rem;
}

.radius-6 {
  border-radius: 1.5rem;
}

.radius-7 {
  border-radius: 1.75rem;
}

.radius-8 {
  border-radius: 2rem;
}

.radius-9 {
  border-radius: 2.25rem;
}

.radius-10 {
  border-radius: 2.5rem;
}

.radius-11 {
  border-radius: 2.75rem;
}

.radius-12 {
  border-radius: 3rem;
}

.radius-full {
  border-radius: 100%;
}

/*width*/
.w-auto {
  width: auto;
}

.w-screen {
  width: 100vw;
}

.w-0 {
  width: 0px;
}

.w-1 {
  width: 0.25rem;
}

.w-2 {
  width: 0.5rem;
}

.w-3 {
  width: 0.5rem;
}

.w-4 {
  width: 1rem;
}

.w-5 {
  width: 1.25rem;
}

.w-6 {
  width: 1.5rem;
}

.w-7 {
  width: 1.5rem;
}

.w-8 {
  width: 2rem;
}

.w-9 {
  width: 2.25rem;
}

.w-10 {
  width: 2.5rem;
}

.w-11 {
  width: 2.5rem;
}

.w-12 {
  width: 3rem;
}

.w-13 {
  width: 3.25rem;
}

.w-14 {
  width: 3.5rem;
}

.w-15 {
  width: 3.5rem;
}

.w-16 {
  width: 4rem;
}

.w-17 {
  width: 4.25rem;
}

.w-18 {
  width: 4.5rem;
}

.w-19 {
  width: 4.5rem;
}

.w-20 {
  width: 5rem;
}

.w-21 {
  width: 5.25rem;
}

.w-22 {
  width: 5.5rem;
}

.w-23 {
  width: 5.5rem;
}

.w-24 {
  width: 6rem;
}

.w-25 {
  width: 7.25rem;
}

.w-26 {
  width: 8.5rem;
}

.w-27 {
  width: 9.5rem;
}

.w-28 {
  width: 10rem;
}

.mw-20 {
  max-width: 20%;
}

.mw-50 {
  max-width: 50%;
}

.mw-100 {
  max-width: 100%;
}

/* Background Colors */
.bg-grey {
  background-color: #F4F6FA;
}

.bg-darkBlue {
  background-color: #110133;
}

.bg-green {
  background-color: #11BC97;
}

.bg-sharpGreen {
  background-color: #01FFCA;
}

.bg-purple {
  background-color: #A001FF;
}

.bg-blue {
  background-color: #2091E9;
}

/* Borders css */
.border {
  border: 1px solid #E4E7F0;
}

.border-bottom {
  border-bottom: 1px solid #E4E7F0;
}

.border-top {
  border-top: 1px solid #E4E7F0;
}

.border-left {
  border-left: 1px solid #E4E7F0;
}

.border-right {
  border-right: 1px solid #E4E7F0;
}

.border-bottom-2 {
  border-bottom: 2px solid #E4E7F0;
}

.border-bottom-3 {
  border-bottom: 3px solid #E4E7F0;
}

.border-bottom-4 {
  border-bottom: 4px solid #E4E7F0;
}

/*Colors*/
.color-green {
  color: #11BC97;
}

.color-pink {
  color: #E66A8B;
}

.color-monoDull {
  color: #A7B2CD;
}

.color-monoNormal {
  color: #636A7D;
}

.color-monoIntense {
  color: #222735;
}

.color-darkBlue {
  color: #110133;
}

.pending {
  color: #FB8C3D;
}

.inprogress {
  color: #2091E9;
}

.complete {
  color: #11BC97;
}

.error {
  color: #E66A8B;
}

.color-greyDull {
  color: rgba(79, 79, 79, 0.6);
}

/* Button css */
.button {
  color: #11BC97;
  padding: 10px 16px;
  border-radius: 8px;
  border: 2px solid #11BC97;
  background: transparent;
}
.button:hover {
  background: #0ead8a;
  border-color: #0ead8a;
}

.btn-grey-border {
  border-color: #A7B2CD;
  color: #A7B2CD;
}
.btn-grey-border:hover {
  color: #ffffff;
}

.button-with-image-and-text {
  display: flex;
  align-items: center;
}
.button-with-image-and-text img, .button-with-image-and-text svg {
  margin-right: 5px;
}
.button-with-image-and-text svg path {
  fill: #11BC97;
}
.button-with-image-and-text:hover svg path {
  fill: #ffffff;
}

.button-with-loader {
  position: relative;
}
.button-with-loader-loading {
  pointer-events: none;
}
.button-with-loader-hidden {
  opacity: 0;
}
.button-with-loader-loader {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.btn-ghost:hover {
  background-color: #11BC97;
  color: #ffffff;
}

.button-group button:first-child {
  margin-right: 12px;
}

.btn-with-icon {
  background-color: #11BC97;
  padding: 10px 16px 10px 12px;
  color: #ffffff;
}

.btn-with-icon.md {
  padding: 4px 14px 4px 6px;
  font-size: 14px;
  height: 40px;
}

.btn-ghost.sm {
  font-size: 12px;
  padding: 4px 8px;
  border-width: 1px;
  border-radius: 4px;
  font-weight: 500;
}

.grey-btn {
  background-color: #a7b2cd;
  border-color: #a7b2cd;
}

.ltGrey-btn {
  background: #E4E7F0;
  border-color: #E4E7F0;
  color: #222735;
}
.ltGrey-btn:hover {
  background-color: #A7B2CD;
  border-color: #A7B2CD;
}

/* Utilities css */
.overlay-loader {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 9;
  background: rgba(244, 246, 250, 0.8705882353);
  display: none;
}
.overlay-loader .loader {
  margin-top: 3rem;
}

.overlay-loader.active {
  display: block;
}

header {
  z-index: 999999;
}

.fw-normal {
  font-weight: normal;
}

.fw-medium {
  font-weight: 600 !important;
}

.row {
  margin: 0;
}

.hvr-float {
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  transition-duration: 0.2s;
  transition-property: transform;
  transition-timing-function: ease-out;
  cursor: pointer;
}
.hvr-float:hover, .hvr-float:focus, .hvr-float:active {
  transform: translateY(-4px);
}

.box-shadow:hover {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  transition: box-shadow 0.3s ease-in-out;
}

.bg-image {
  background-size: cover !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
}

.back-btn {
  padding: 0.5rem 0.75rem;
  border: 0;
  border-radius: 0.5rem;
  margin-right: 1rem;
  background-color: #E4E7F0;
}
.back-btn:hover {
  background-color: #A7B2CD;
}

.hvg-bg:hover {
  background-color: #F4F6FA;
}

.hidden {
  display: none;
}

.show {
  display: block;
}

.cursor-pointer {
  cursor: pointer;
}

/* main wrapper css */
.main {
  overflow-x: hidden;
}

.wrapper {
  padding-top: 70px;
}

.main-content {
  padding-left: 240px;
}

.badge {
  font-size: 11px !important;
}

p.badge {
  margin: 0;
  width: 64px !important;
  height: 20px !important;
  text-align: center;
  letter-spacing: -0.3px;
  padding-left: 0 !important;
  padding-right: 0 !important;
  font-weight: 600;
}

.badge-color-high {
  background-color: #F4B717;
}

.badge-pink {
  background: #E66A8B;
}

.badge-color-exact {
  background: #E66A8B;
  border: 1px solid #E66A8B;
}

.badge-color-very-high {
  background-color: #FB8C3D;
  border: 1px solid #FB8C3D;
}

.badge-color-medium {
  background-color: #7879F1;
  border: 1px solid #7879F1;
}

.badge-color-low {
  background-color: #2091E9;
  border: 1px solid #2091E9;
}

.badge-color-very-low {
  background-color: #a7b2cd;
  border: 1px solid #a7b2cd;
}

.badge-color-no-match {
  background-color: #ffffff;
  border: 1px solid #A7B2CD;
  color: #A7B2CD;
}

p.badge.badge-risk {
  width: auto !important;
  height: auto !important;
  padding: 0.35rem !important;
}

.badge-color-risk-sanctioned {
  color: #E66A8B;
  background-color: #FFF3F6;
  border: 1px solid #FFF3F6;
}

.badge-color-risk-very-high {
  color: #E66A8B;
  background-color: #FFF3F6;
  border: 1px solid #FFF3F6;
}

.badge-color-risk-high {
  color: #AF5412;
  background-color: #FEE0CB;
  border: 1px solid #FEE0CB;
}

.badge-color-risk-medium {
  color: #0090C1;
  background-color: #CFEFFB;
  border: 1px solid #CFEFFB;
}

.badge-color-risk-low {
  color: #11BC97;
  background-color: #E7F8F5;
  border: 1px solid #E7F8F5;
}

.badge-color-risk-none {
  background-color: #F4F6FA;
  border: 1px solid #F4F6FA;
  color: #626A7C;
}

.badge-color-risk-error-match {
  color: #FFF3F6;
  background-color: #E66A8B;
  border: 1px solid #E66A8B;
}

.content-box {
  padding: 2rem;
}

.card {
  border-color: #E4E7F0 !important;
  padding: 1.5rem;
  border-radius: 0.5rem !important;
  overflow: hidden;
}
.card input,
.card select {
  height: 48px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  color: #222735 !important;
}

.select-with-left-icon,
.input-with-left-icon {
  position: relative;
}

.select-with-left-icon select,
.input-with-left-icon input {
  padding: 0.375rem 2.25rem;
}

.select-with-left-icon img,
.input-with-left-icon img {
  position: absolute;
  left: 8px;
  top: 12px;
}

/* Pagination css */
.pagination {
  background: #ffffff;
  color: #636A7D;
  font-size: 0.75rem;
}
.pagination input {
  width: 80px;
  text-align: center;
}
.pagination select {
  width: 4rem !important;
  margin-right: 0.5rem;
}

.pagination.table-listing {
  width: 100%;
  bottom: 0;
  left: 0;
  background-color: #ffffff;
}

.pagination input,
.pagination select {
  border: 1px solid #E4E7F0;
  border-radius: 0.5rem;
  padding: 5px 1rem;
  height: 32px;
}

.pagination-btns button {
  border: 0;
  padding: 4px;
  background-color: #11BC97;
  margin: 0 2px;
}
.pagination-btns button:hover {
  background: #0ead8a;
  border-color: #0ead8a;
}

.pagination-btns button.disabled {
  background-color: #E4E7F0;
}

.pagination-btns button:first-child {
  border-radius: 8px 0px 0px 8px;
}

.pagination-btns button:last-child {
  border-radius: 0px 8px 8px 0px;
}

.card-sm {
  cursor: pointer;
  padding: 1rem;
  width: 150px;
  flex-basis: 150px;
  flex-grow: 1;
}

.card-sm h5 {
  font-size: 1rem;
  margin: 0;
  font-weight: normal;
  line-height: 1.5rem;
}

.card-sm h4.opacity-0 {
  opacity: 0;
}

.card-sm.active.exact {
  border-top: 4px solid #E66A8B !important;
}
.card-sm.active.very-high {
  border-top: 4px solid #FB8C3D !important;
}
.card-sm.active.high {
  border-top: 4px solid #F4B717 !important;
}
.card-sm.active.medium {
  border-top: 4px solid #7879F1 !important;
}
.card-sm.active.low {
  border-top: 4px solid #2091E9 !important;
}
.card-sm.active.very-low {
  border-top: 4px solid #a7b2cd !important;
}

.card-sm.active h4 {
  color: #110133;
}

.card.top-head {
  border-radius: 0 0 8px 8px !important;
}

.ew-cols > div {
  width: 150px;
  flex-basis: 150px;
  flex-grow: 1;
}

.dynamic-countries {
  font-size: 14px;
}
.dynamic-countries .css-1okebmr-indicatorSeparator {
  display: none;
}
.dynamic-countries input {
  height: 34px;
}
.dynamic-countries svg {
  transform: rotate(0deg) !important;
}
.dynamic-countries svg path {
  fill: #80889c;
}
.dynamic-countries .css-1s2u09g-control {
  border-radius: 0.5rem !important;
}
.dynamic-countries .css-1pahdxg-control {
  border-color: #80bdff !important;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #636A7D !important;
  opacity: 0.4 !important; /* Firefox */
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #636A7D !important;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #636A7D !important;
}

/* .result-list .heading span{
	position: sticky;
    top: 0;
    background-color: \$color-white;
} */
.overflow-visible {
  overflow: visible;
}

.ew-cols .button-group {
  width: auto;
  flex-basis: auto;
  flex-grow: inherit;
}

.custom-checkbox {
  display: block;
  margin-bottom: 15px;
}

.custom-checkbox input {
  padding: 0;
  height: initial;
  width: initial;
  margin-bottom: 0;
  display: none;
  cursor: pointer;
}

.custom-checkbox label {
  position: relative;
  cursor: pointer;
  color: #11bc97;
  font-size: 16px;
  margin-left: 3px;
}

.custom-checkbox label:before {
  content: "";
  -webkit-appearance: none;
  background-color: transparent;
  border: 2px solid #11bc97;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);
  padding: 10px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  cursor: pointer;
  margin-right: 8px;
  border-radius: 4px;
}

.custom-checkbox input:checked + label:after {
  content: "";
  display: block;
  position: absolute;
  top: 4px;
  left: 9px;
  width: 6px;
  height: 14px;
  border: solid #11bc97;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

@media only screen and (min-width: 1300px) and (max-width: 1800px) {
  body {
    /* webkit browsers */
    zoom: 85%;
    /* moz browsers , since there is no support to "zoom" */
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/_spacing.scss","webpack://./src/styles/globalStyles.scss","webpack://./src/styles/_colors.scss"],"names":[],"mappings":"AAAA,aAAA;AACA;EACC,mBAAA;ACGD;;ADDA;EACC,kBAAA;ACID;;ADFA;EACC,mBAAA;ACKD;;ADHA;EACC,gBAAA;ACMD;;ADJA;EACC,mBAAA;ACOD;;ADLA;EACC,kBAAA;ACQD;;ADNA;EACC,mBAAA;ACSD;;ADPA;EACC,gBAAA;ACUD;;ADRA;EACC,mBAAA;ACWD;;ADTA;EACC,kBAAA;ACYD;;ADVA;EACC,mBAAA;ACaD;;ADXA;EACC,gBAAA;ACcD;;ADZA;EACC,mBAAA;ACeD;;ADbA;EACC,kBAAA;ACgBD;;ADdA;EACC,mBAAA;ACiBD;;ADfA;EACC,gBAAA;ACkBD;;ADhBA;EACC,mBAAA;ACmBD;;ADjBA;EACC,kBAAA;ACoBD;;ADlBA;EACC,mBAAA;ACqBD;;ADnBA;EACC,gBAAA;ACsBD;;ADpBA;EACC,mBAAA;ACuBD;;ADrBA;EACC,kBAAA;ACwBD;;ADtBA;EACC,mBAAA;ACyBD;;ADvBA;EACC,gBAAA;AC0BD;;ADvBA;EACC,sBAAA;AC0BD;;ADxBA;EACC,qBAAA;AC2BD;;ADzBA;EACC,sBAAA;AC4BD;;AD1BA;EACC,mBAAA;AC6BD;;AD3BA;EACC,sBAAA;AC8BD;;AD5BA;EACC,qBAAA;AC+BD;;AD7BA;EACC,sBAAA;ACgCD;;AD9BA;EACC,mBAAA;ACiCD;;AD/BA;EACC,sBAAA;ACkCD;;ADhCA;EACC,qBAAA;ACmCD;;ADjCA;EACC,sBAAA;ACoCD;;ADlCA;EACC,mBAAA;ACqCD;;ADnCA;EACC,sBAAA;ACsCD;;ADpCA;EACC,qBAAA;ACuCD;;ADrCA;EACC,sBAAA;ACwCD;;ADtCA;EACC,mBAAA;ACyCD;;ADtCA,oBAAA;AACA;EACC,iBAAA;ACyCD;;ADvCA;EACC,gBAAA;AC0CD;;ADxCA;EACC,iBAAA;AC2CD;;ADzCA;EACC,cAAA;AC4CD;;AD1CA;EACC,iBAAA;AC6CD;;AD3CA;EACC,gBAAA;AC8CD;;AD5CA;EACC,iBAAA;AC+CD;;AD7CA;EACC,cAAA;ACgDD;;AD9CA;EACC,iBAAA;ACiDD;;AD/CA;EACC,gBAAA;ACkDD;;ADhDA;EACC,iBAAA;ACmDD;;ADjDA;EACC,cAAA;ACoDD;;ADlDA;EACC,iBAAA;ACqDD;;ADnDA;EACC,gBAAA;ACsDD;;ADpDA;EACC,iBAAA;ACuDD;;ADrDA;EACC,cAAA;ACwDD;;ADtDA;EACC,iBAAA;ACyDD;;ADvDA;EACC,gBAAA;AC0DD;;ADxDA;EACC,iBAAA;AC2DD;;ADzDA;EACC,cAAA;AC4DD;;AD1DA;EACC,iBAAA;AC6DD;;AD3DA;EACC,gBAAA;AC8DD;;AD5DA;EACC,iBAAA;AC+DD;;AD7DA;EACC,cAAA;ACgED;;AD7DA,sBAAA;AACA;EACC,iBAAA;ACgED;;AD9DA;EACC,gBAAA;ACiED;;AD/DA;EACC,iBAAA;ACkED;;ADhEA;EACC,cAAA;ACmED;;ADjEA;EACC,iBAAA;ACoED;;ADlEA;EACC,gBAAA;ACqED;;ADnEA;EACC,iBAAA;ACsED;;ADpEA;EACC,cAAA;ACuED;;ADrEA;EACC,iBAAA;ACwED;;ADtEA;EACC,gBAAA;ACyED;;ADvEA;EACC,iBAAA;AC0ED;;ADxEA;EACC,cAAA;AC2ED;;ADzEA;EACC,iBAAA;AC4ED;;AD1EA;EACC,gBAAA;AC6ED;;AD3EA;EACC,iBAAA;AC8ED;;AD5EA;EACC,cAAA;AC+ED;;AD7EA;EACC,iBAAA;ACgFD;;AD9EA;EACC,gBAAA;ACiFD;;AD/EA;EACC,iBAAA;ACkFD;;ADhFA;EACC,cAAA;ACmFD;;ADjFA;EACC,iBAAA;ACoFD;;ADlFA;EACC,gBAAA;ACqFD;;ADnFA;EACC,iBAAA;ACsFD;;ADpFA;EACC,cAAA;ACuFD;;ADlFA,sCAAA;AACA;EACC,gBAAA;ACqFD;;ADnFA;EACC,eAAA;ACsFD;;ADpFA;EACC,gBAAA;ACuFD;;ADrFA;EACC,wBAAA;ACwFD;;ADtFA;EACC,aAAA;ACyFD;;ADvFA;EACC,gBAAA;AC0FD;;ADxFA;EACC,eAAA;AC2FD;;ADzFA;EACC,gBAAA;AC4FD;;AD1FA;EACC,aAAA;AC6FD;;AD3FA;EACC,gBAAA;AC8FD;;AD5FA;EACC,eAAA;AC+FD;;AD7FA;EACC,gBAAA;ACgGD;;AD9FA;EACC,aAAA;ACiGD;;AD/FA;EACC,gBAAA;ACkGD;;ADhGA;EACC,eAAA;ACmGD;;ADjGA;EACC,gBAAA;ACoGD;;ADlGA;EACC,aAAA;ACqGD;;ADnGA;EACC,gBAAA;ACsGD;;ADpGA;EACC,eAAA;ACuGD;;ADrGA;EACC,gBAAA;ACwGD;;ADtGA;EACC,aAAA;ACyGD;;ADvGA;EACC,gBAAA;AC0GD;;ADxGA;EACC,eAAA;AC2GD;;ADzGA;EACC,gBAAA;AC4GD;;AD1GA;EACC,aAAA;AC6GD;;AD1GA,qBAAA;AACA;EACC,kBAAA;AC6GD;;AD3GA;EACC,iBAAA;AC8GD;;AD5GA;EACC,kBAAA;AC+GD;;AD7GA;EACC,eAAA;ACgHD;;AD9GA;EACC,kBAAA;ACiHD;;AD/GA;EACC,iBAAA;ACkHD;;ADhHA;EACC,kBAAA;ACmHD;;ADjHA;EACC,eAAA;ACoHD;;ADlHA;EACC,kBAAA;ACqHD;;ADnHA;EACC,iBAAA;ACsHD;;ADpHA;EACC,kBAAA;ACuHD;;ADrHA;EACC,eAAA;ACwHD;;ADtHA;EACC,kBAAA;ACyHD;;ADvHA;EACC,iBAAA;AC0HD;;ADxHA;EACC,kBAAA;AC2HD;;ADzHA;EACC,eAAA;AC4HD;;AD1HA;EACC,kBAAA;AC6HD;;AD3HA;EACC,iBAAA;AC8HD;;AD5HA;EACC,kBAAA;AC+HD;;AD7HA;EACC,eAAA;ACgID;;AD9HA;EACC,kBAAA;ACiID;;AD/HA;EACC,iBAAA;ACkID;;ADhIA;EACC,kBAAA;ACmID;;ADjIA;EACC,eAAA;ACoID;;ADhIA,uBAAA;AACA;EACC,kBAAA;ACmID;;ADjIA;EACC,iBAAA;ACoID;;ADlIA;EACC,6BAAA;ACqID;;ADnIA;EACC,eAAA;ACsID;;ADpIA;EACC,kBAAA;ACuID;;ADrIA;EACC,iBAAA;ACwID;;ADtIA;EACC,kBAAA;ACyID;;ADvIA;EACC,eAAA;AC0ID;;ADxIA;EACC,kBAAA;AC2ID;;ADzIA;EACC,iBAAA;AC4ID;;AD1IA;EACC,kBAAA;AC6ID;;AD3IA;EACC,eAAA;AC8ID;;AD5IA;EACC,kBAAA;AC+ID;;AD7IA;EACC,iBAAA;ACgJD;;AD9IA;EACC,kBAAA;ACiJD;;AD/IA;EACC,eAAA;ACkJD;;ADhJA;EACC,kBAAA;ACmJD;;ADjJA;EACC,iBAAA;ACoJD;;ADlJA;EACC,kBAAA;ACqJD;;ADnJA;EACC,eAAA;ACsJD;;ADpJA;EACC,kBAAA;ACuJD;;ADrJA;EACC,iBAAA;ACwJD;;ADtJA;EACC,kBAAA;ACyJD;;ADvJA;EACC,eAAA;AC0JD;;AAroBA;EACE,oCAAA;EACA,2BAAA;AAwoBF;;AAtoBA;EACE,gCAAA;AAyoBF;;AAvoBA;EACE,+BAAA;AA0oBF;;AAxoBA;EACE,iCAAA;AA2oBF;;AAzoBA;EACE,yBAAA;AA4oBF;;AA1oBA;EACE,gCAAA;AA6oBF;;AA3oBA;EACE,mBAAA;AA8oBF;;AA5oBA;EACE,4BAAA;EACA,wBAAA;EAGA,gBAAA;AA+oBF;;AA7oBA;EACE,eAAA;AAgpBF;;AA9oBA;EACE,eAAA;AAipBF;;AA/oBA;EACE,eAAA;AAkpBF;;AAhpBA;EACE,eAAA;AAmpBF;;AAjpBA;EACE,eAAA;AAopBF;;AAlpBA;EACE,8BAAA;AAqpBF;;AAnpBA;EACE,8BAAA;AAspBF;;AAppBA;;EAEE,cCzCoB;ADgsBtB;;AArpBA;EACE,eAAA;AAwpBF;;AArpBA,SAAA;AACA;EACE,uBAAA;AAwpBF;;AAtpBA;EACE,sBAAA;AAypBF;;AAvpBA;EACE,uBAAA;AA0pBF;;AAxpBA;EACE,oBAAA;AA2pBF;;AAzpBA;EACE,uBAAA;AA4pBF;;AA1pBA;EACE,sBAAA;AA6pBF;;AA3pBA;EACE,uBAAA;AA8pBF;;AA5pBA;EACE,oBAAA;AA+pBF;;AA7pBA;EACE,SAAA;AAgqBF;;AA9pBA;EACE,SAAA;AAiqBF;;AA9pBA,kBAAA;AACA;EACE,mBAAA;AAiqBF;;AA/pBA;EACE,sBAAA;AAkqBF;;AAhqBA;EACE,qBAAA;AAmqBF;;AAjqBA;EACE,sBAAA;AAoqBF;;AAlqBA;EACE,mBAAA;AAqqBF;;AAnqBA;EACE,sBAAA;AAsqBF;;AApqBA;EACE,qBAAA;AAuqBF;;AArqBA;EACE,sBAAA;AAwqBF;;AAtqBA;EACE,mBAAA;AAyqBF;;AAvqBA;EACE,sBAAA;AA0qBF;;AAxqBA;EACE,qBAAA;AA2qBF;;AAzqBA;EACE,sBAAA;AA4qBF;;AA1qBA;EACE,mBAAA;AA6qBF;;AA3qBA;EACE,mBAAA;AA8qBF;;AA3qBA,QAAA;AACA;EACE,WAAA;AA8qBF;;AA5qBA;EACE,YAAA;AA+qBF;;AA5qBA;EACE,UAAA;AA+qBF;;AA7qBA;EACE,cAAA;AAgrBF;;AA9qBA;EACE,aAAA;AAirBF;;AA/qBA;EACE,aAAA;AAkrBF;;AAhrBA;EACE,WAAA;AAmrBF;;AAjrBA;EACE,cAAA;AAorBF;;AAlrBA;EACE,aAAA;AAqrBF;;AAnrBA;EACE,aAAA;AAsrBF;;AAprBA;EACE,WAAA;AAurBF;;AArrBA;EACE,cAAA;AAwrBF;;AAtrBA;EACE,aAAA;AAyrBF;;AAvrBA;EACE,aAAA;AA0rBF;;AAxrBA;EACE,WAAA;AA2rBF;;AAzrBA;EACE,cAAA;AA4rBF;;AA1rBA;EACE,aAAA;AA6rBF;;AA3rBA;EACE,aAAA;AA8rBF;;AA5rBA;EACE,WAAA;AA+rBF;;AA7rBA;EACE,cAAA;AAgsBF;;AA9rBA;EACE,aAAA;AAisBF;;AA/rBA;EACE,aAAA;AAksBF;;AAhsBA;EACE,WAAA;AAmsBF;;AAjsBA;EACE,cAAA;AAosBF;;AAlsBA;EACE,aAAA;AAqsBF;;AAnsBA;EACE,aAAA;AAssBF;;AApsBA;EACE,WAAA;AAusBF;;AArsBA;EACE,cAAA;AAwsBF;;AAtsBA;EACE,aAAA;AAysBF;;AAvsBA;EACE,aAAA;AA0sBF;;AAxsBA;EACE,YAAA;AA2sBF;;AAxsBA;EACE,cAAA;AA2sBF;;AAzsBA;EACE,cAAA;AA4sBF;;AA1sBA;EACE,eAAA;AA6sBF;;AA1sBA,sBAAA;AACA;EACE,yBC1Oe;ADu7BjB;;AA3sBA;EACE,yBC9Oc;AD47BhB;;AA5sBA;EACE,yBC3PW;AD08Bb;;AA7sBA;EACE,yBC3PgB;AD28BlB;;AA9sBA;EACE,yBCzPY;AD08Bd;;AA/sBA;EACE,yBClQU;ADo9BZ;;AA/sBA,gBAAA;AACA;EACE,yBAAA;AAktBF;;AAhtBA;EACE,gCAAA;AAmtBF;;AAjtBA;EACE,6BAAA;AAotBF;;AAltBA;EACE,8BAAA;AAqtBF;;AAntBA;EACE,+BAAA;AAstBF;;AAptBA;EACE,gCAAA;AAutBF;;AArtBA;EACE,gCAAA;AAwtBF;;AArtBA;EACE,gCAAA;AAwtBF;;AArtBA,SAAA;AACA;EACE,cCpSW;AD4/Bb;;AAttBA;EACE,cCnSU;AD4/BZ;;AAvtBA;EACE,cC7RkB;ADu/BpB;;AAxtBA;EACE,cC/RoB;AD0/BtB;;AAztBA;EACE,cChSqB;AD4/BvB;;AA1tBA;EACE,cCzSc;ADsgChB;;AA3tBA;EACE,cCjTY;AD+gCd;;AA5tBA;EACE,cCvTU;ADshCZ;;AA7tBA;EACE,cC5TW;AD4hCb;;AA9tBA;EACE,cC3TU;AD4hCZ;;AA/tBA;EACE,4BAAA;AAkuBF;;AA/tBA,eAAA;AACA;EACE,cCvUW;EDwUX,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;AAkuBF;AAjuBE;EACE,mBC5UY;ED6UZ,qBC7UY;ADgjChB;;AA/tBA;EACE,qBCtUkB;EDuUlB,cCvUkB;ADyiCpB;AAjuBE;EACE,cCxVU;AD2jCd;;AA/tBA;EACE,aAAA;EACA,mBAAA;AAkuBF;AAhuBE;EACE,iBAAA;AAkuBJ;AA9tBI;EACE,aCpWO;ADokCb;AA3tBI;EACE,aC5WQ;ADykCd;;AAxtBA;EACE,kBAAA;AA2tBF;AAztBE;EACE,oBAAA;AA2tBJ;AAxtBE;EACE,UAAA;AA0tBJ;AAvtBE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;AAytBJ;;AAptBE;EACE,yBCrYS;EDsYT,cCxYU;AD+lCd;;AAptBA;EACE,kBAAA;AAutBF;;AArtBA;EACE,yBC7YW;ED8YX,4BAAA;EACA,cCjZY;ADymCd;;AAttBA;EACE,yBAAA;EACA,eAAA;EACA,YAAA;AAytBF;;AAvtBA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AA0tBF;;AAxtBA;EACE,yBAAA;EACA,qBAAA;AA2tBF;;AAztBA;EACE,mBCtZgB;EDuZhB,qBCvZgB;EDwZhB,cCpZqB;ADgnCvB;AA3tBE;EACE,yBCzZgB;ED0ZhB,qBC1ZgB;ADunCpB;;AAztBA,kBAAA;AACA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,6CAAA;EACA,aAAA;AA4tBF;AA3tBE;EACE,gBAAA;AA6tBJ;;AA1tBA;EACE,cAAA;AA6tBF;;AA3tBA;EACE,eAAA;AA8tBF;;AA5tBA;EACE,mBAAA;AA+tBF;;AA7tBA;EACE,2BAAA;AAguBF;;AA9tBA;EACE,SAAA;AAiuBF;;AA/tBA;EAEE,yCAAA;EACA,oCAAA;EAEA,yBAAA;EAEA,8BAAA;EAEA,oCAAA;EACA,eAAA;AAkuBF;AAjuBE;EAKE,2BAAA;AAiuBJ;;AA9tBA;EACE,iDAAA;EACA,uCAAA;AAiuBF;;AA/tBA;EACE,iCAAA;EACA,sCAAA;EACA,uCAAA;AAkuBF;;AAhuBA;EACE,uBAAA;EACA,SAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBC3dgB;AD8rClB;AAluBE;EACE,yBC5dgB;ADgsCpB;;AAjuBA;EACE,yBClee;ADssCjB;;AAluBA;EACE,aAAA;AAquBF;;AAnuBA;EACE,cAAA;AAsuBF;;AApuBA;EACE,eAAA;AAuuBF;;AApuBA,qBAAA;AACA;EACE,kBAAA;AAuuBF;;AAruBA;EACE,iBAAA;AAwuBF;;AAtuBA;EACE,mBAAA;AAyuBF;;AAvuBA;EACE,0BAAA;AA0uBF;;AAxuBA;EACE,SAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,gBAAA;AA2uBF;;AAzuBA;EACE,yBC3gBiB;ADuvCnB;;AA1uBA;EACE,mBChhBU;AD6vCZ;;AA3uBA;EACE,mBCnhBU;EDohBV,yBAAA;AA8uBF;;AA5uBA;EACE,yBCphBY;EDqhBZ,yBAAA;AA+uBF;;AA7uBA;EACE,yBCthBkB;EDuhBlB,yBAAA;AAgvBF;;AA9uBA;EACE,yBCjiBU;EDkiBV,yBAAA;AAivBF;;AA/uBA;EACE,yBCxhBgB;EDyhBhB,yBAAA;AAkvBF;;AAhvBA;EACE,yBC7iBY;ED8iBZ,yBAAA;EACA,cChiBkB;ADmxCpB;;AAhvBA;EACE,sBAAA;EACA,uBAAA;EACA,2BAAA;AAmvBF;;AAjvBA;EACE,cAAA;EACA,yBAAA;EACA,yBAAA;AAovBF;;AAlvBA;EACE,cAAA;EACA,yBAAA;EACA,yBAAA;AAqvBF;;AAnvBA;EACE,cAAA;EACA,yBAAA;EACA,yBAAA;AAsvBF;;AApvBA;EACE,cAAA;EACA,yBAAA;EACA,yBAAA;AAuvBF;;AArvBA;EACE,cAAA;EACA,yBAAA;EACA,yBAAA;AAwvBF;;AAtvBA;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;AAyvBF;;AAvvBA;EACE,cAAA;EACA,yBAAA;EACA,yBAAA;AA0vBF;;AAvvBA;EACE,aAAA;AA0vBF;;AAxvBA;EACE,gCAAA;EACA,eAAA;EACA,gCAAA;EACA,gBAAA;AA2vBF;AA1vBE;;EAEE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;AA4vBJ;;AAxvBA;;EAEE,kBAAA;AA2vBF;;AAzvBA;;EAEE,yBAAA;AA4vBF;;AA1vBA;;EAEE,kBAAA;EACA,SAAA;EACA,SAAA;AA6vBF;;AA1vBA,mBAAA;AACA;EACE,mBC/nBY;EDgoBZ,cChnBoB;EDinBpB,kBAAA;AA6vBF;AA5vBE;EACE,WAAA;EACA,kBAAA;AA8vBJ;AA5vBE;EACE,sBAAA;EACA,oBAAA;AA8vBJ;;AA3vBA;EACE,WAAA;EACA,SAAA;EACA,OAAA;EACA,yBC/oBY;AD64Cd;;AA5vBA;;EAEE,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,YAAA;AA+vBF;;AA7vBA;EACE,SAAA;EACA,YAAA;EACA,yBCzpBW;ED0pBX,aAAA;AAgwBF;AA/vBE;EACE,mBC3pBY;ED4pBZ,qBC5pBY;AD65ChB;;AA9vBA;EACE,yBCrpBgB;ADs5ClB;;AA/vBA;EACE,8BAAA;AAkwBF;;AAhwBA;EACE,8BAAA;AAmwBF;;AAjwBA;EACE,eAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;AAowBF;;AAlwBA;EACE,eAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;AAqwBF;;AAnwBA;EACE,UAAA;AAswBF;;AAnwBE;EACE,wCAAA;AAswBJ;AApwBE;EACE,wCAAA;AAswBJ;AApwBE;EACE,wCAAA;AAswBJ;AApwBE;EACE,wCAAA;AAswBJ;AApwBE;EACE,wCAAA;AAswBJ;AApwBE;EACE,wCAAA;AAswBJ;;AAnwBA;EACE,cCpsBc;AD08ChB;;AAnwBA;EACE,qCAAA;AAswBF;;AApwBA;EACE,YAAA;EACA,iBAAA;EACA,YAAA;AAuwBF;;AArwBA;EACE,eAAA;AAwwBF;AAvwBE;EACE,aAAA;AAywBJ;AAvwBE;EACE,YAAA;AAywBJ;AAvwBE;EACE,kCAAA;AAywBJ;AAxwBI;EAEE,aAAA;AAywBN;AAtwBE;EACE,gCAAA;AAwwBJ;AAtwBE;EACE,gCAAA;EACA,UAAA;EACA,2DAAA;AAwwBJ;;AApwBA;EACE,yCAAA;EACA,yBAAA;EACA,uBAAA,EAAA,YAAA;AAuwBF;;AArwBA;EACE,4BAAA;EACA,yBAAA;AAwwBF;;AAtwBA;EACE,mBAAA;EACA,yBAAA;AAywBF;;AAvwBA;;;;GAAA;AAKA;EACE,iBAAA;AA0wBF;;AAxwBA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;AA2wBF;;AAxwBA;EACE,cAAA;EACA,mBAAA;AA2wBF;;AAzwBA;EACE,UAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;AA4wBF;;AA1wBA;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA6wBF;;AA3wBA;EACE,WAAA;EACA,wBAAA;EACA,6BAAA;EACA,yBAAA;EACA,yFAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AA8wBF;;AA5wBA;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;EACA,wBAAA;AA+wBF;;AA5wBA;EACE;IACE,oBAAA;IACA,SAAA;IACA,uDAAA;EA+wBF;AACF","sourcesContent":["/*Margin Top*/\n.mt-1{\n\tmargin-top: 0.25rem;\n}\n.mt-2{\n\tmargin-top: 0.5rem;\n}\n.mt-3{\n\tmargin-top: 0.75rem;\n}\n.mt-4{\n\tmargin-top: 1rem;\n}\n.mt-5{\n\tmargin-top: 1.25rem;\n}\n.mt-6{\n\tmargin-top: 1.5rem;\n}\n.mt-7{\n\tmargin-top: 1.75rem;\n}\n.mt-8{\n\tmargin-top: 2rem;\n}\n.mt-9{\n\tmargin-top: 2.25rem;\n}\n.mt-10{\n\tmargin-top: 2.5rem;\n}\n.mt-11{\n\tmargin-top: 2.75rem;\n}\n.mt-12{\n\tmargin-top: 3rem;\n}\n.mt-13{\n\tmargin-top: 3.25rem;\n}\n.mt-14{\n\tmargin-top: 3.5rem;\n}\n.mt-15{\n\tmargin-top: 3.75rem;\n}\n.mt-16{\n\tmargin-top: 4rem;\n}\n.mt-17{\n\tmargin-top: 4.25rem;\n}\n.mt-18{\n\tmargin-top: 4.5rem;\n}\n.mt-19{\n\tmargin-top: 4.75rem;\n}\n.mt-20{\n\tmargin-top: 5rem;\n}\n.mt-21{\n\tmargin-top: 5.25rem;\n}\n.mt-22{\n\tmargin-top: 5.5rem;\n}\n.mt-23{\n\tmargin-top: 5.75rem;\n}\n.mt-24{\n\tmargin-top: 6rem;\n}\n\n.mb-1{\n\tmargin-bottom: 0.25rem;\t\n}\n.mb-2{\n\tmargin-bottom: 0.5rem;\t\n}\n.mb-3{\n\tmargin-bottom: 0.75rem;\t\n}\n.mb-4{\n\tmargin-bottom: 1rem;\t\n}\n.mb-5{\n\tmargin-bottom: 1.25rem;\t\n}\n.mb-6{\n\tmargin-bottom: 1.5rem;\t\n}\n.mb-7{\n\tmargin-bottom: 1.75rem;\t\n}\n.mb-8{\n\tmargin-bottom: 2rem;\t\n}\n.mb-9{\n\tmargin-bottom: 2.25rem;\t\n}\n.mb-10{\n\tmargin-bottom: 2.5rem;\t\n}\n.mb-11{\n\tmargin-bottom: 2.75rem;\t\n}\n.mb-12{\n\tmargin-bottom: 3rem;\t\n}\n.mb-13{\n\tmargin-bottom: 3.25rem;\t\n}\n.mb-14{\n\tmargin-bottom: 3.5rem;\t\n}\n.mb-15{\n\tmargin-bottom: 3.75rem;\t\n}\n.mb-16{\n\tmargin-bottom: 4rem;\t\n}\n\n/*Margin Vertically*/\n.my-1{\n\tmargin: 0.25rem 0;\n}\n.my-2{\n\tmargin: 0.5rem 0;\n}\n.my-3{\n\tmargin: 0.75rem 0;\n}\n.my-4{\n\tmargin: 1rem 0;\n}\n.my-5{\n\tmargin: 1.25rem 0;\n}\n.my-6{\n\tmargin: 1.5rem 0;\n}\n.my-7{\n\tmargin: 1.75rem 0;\n}\n.my-8{\n\tmargin: 2rem 0;\n}\n.my-9{\n\tmargin: 2.25rem 0;\n}\n.my-10{\n\tmargin: 2.5rem 0;\n}\n.my-11{\n\tmargin: 2.75rem 0;\n}\n.my-12{\n\tmargin: 3rem 0;\n}\n.my-13{\n\tmargin: 3.25rem 0;\n}\n.my-14{\n\tmargin: 3.5rem 0;\n}\n.my-15{\n\tmargin: 3.75rem 0;\n}\n.my-16{\n\tmargin: 4rem 0;\n}\n.my-17{\n\tmargin: 4.25rem 0;\n}\n.my-18{\n\tmargin: 4.5rem 0;\n}\n.my-19{\n\tmargin: 4.75rem 0;\n}\n.my-20{\n\tmargin: 5rem 0;\n}\n.my-21{\n\tmargin: 5.25rem 0;\n}\n.my-22{\n\tmargin: 5.5rem 0;\n}\n.my-23{\n\tmargin: 5.75rem 0;\n}\n.my-24{\n\tmargin: 6rem 0;\n}\n\n/*Margin horizontally*/\n.mx-1{\n\tmargin:0 0.25rem;\n}\n.mx-2{\n\tmargin:0 0.5rem;\n}\n.mx-3{\n\tmargin:0 0.75rem;\n}\n.mx-4{\n\tmargin:0 1rem;\n}\n.mx-5{\n\tmargin:0 1.25rem;\n}\n.mx-6{\n\tmargin:0 1.5rem;\n}\n.mx-7{\n\tmargin:0 1.75rem;\n}\n.mx-8{\n\tmargin:0 2rem;\n}\n.mx-9{\n\tmargin:0 2.25rem;\n}\n.mx-10{\n\tmargin:0 2.5rem;\n}\n.mx-11{\n\tmargin:0 2.75rem;\n}\n.mx-12{\n\tmargin:0 3rem;\n}\n.mx-13{\n\tmargin:0 3.25rem;\n}\n.mx-14{\n\tmargin:0 3.5rem;\n}\n.mx-15{\n\tmargin:0 3.75rem;\n}\n.mx-16{\n\tmargin:0 4rem;\n}\n.mx-17{\n\tmargin:0 4.25rem;\n}\n.mx-18{\n\tmargin:0 4.5rem;\n}\n.mx-19{\n\tmargin:0 4.75rem;\n}\n.mx-20{\n\tmargin:0 5rem;\n}\n.mx-21{\n\tmargin:0 5.25rem;\n}\n.mx-22{\n\tmargin:0 5.5rem;\n}\n.mx-23{\n\tmargin:0 5.75rem;\n}\n.mx-24{\n\tmargin:0 6rem;\n}\n\n\n\n/*Padding Vertically and Horizontally*/\n.p-1{\n\tpadding: 0.25rem;\n}\n.p-2{\n\tpadding: 0.5rem;\n}\n.p-3{\n\tpadding: 0.75rem;\n}\n.p-4{\n\tpadding: 1rem !important;\n}\n.pad-4{\n\tpadding: 1rem;\n}\n.p-5{\n\tpadding: 1.25rem;\n}\n.p-6{\n\tpadding: 1.5rem;\n}\n.p-7{\n\tpadding: 1.75rem;\n}\n.p-8{\n\tpadding: 2rem;\n}\n.p-9{\n\tpadding: 2.25rem;\n}\n.p-10{\n\tpadding: 2.5rem;\n}\n.p-11{\n\tpadding: 2.75rem;\n}\n.p-12{\n\tpadding: 3rem;\n}\n.p-13{\n\tpadding: 3.25rem;\n}\n.p-14{\n\tpadding: 3.5rem;\n}\n.p-15{\n\tpadding: 3.75rem;\n}\n.p-16{\n\tpadding: 4rem;\n}\n.p-17{\n\tpadding: 4.25rem;\n}\n.p-18{\n\tpadding: 4.5rem;\n}\n.p-19{\n\tpadding: 4.75rem;\n}\n.p-20{\n\tpadding: 5rem;\n}\n.p-21{\n\tpadding: 5.25rem;\n}\n.p-22{\n\tpadding: 5.5rem;\n}\n.p-23{\n\tpadding: 5.75rem;\n}\n.p-24{\n\tpadding: 6rem;\n}\n\n/*Padding Vertically*/\n.py-1{\n\tpadding: 0.25rem 0;\n}\n.py-2{\n\tpadding: 0.5rem 0;\n}\n.py-3{\n\tpadding: 0.75rem 0;\n}\n.py-4{\n\tpadding: 1rem 0;\n}\n.py-5{\n\tpadding: 1.25rem 0;\n}\n.py-6{\n\tpadding: 1.5rem 0;\n}\n.py-7{\n\tpadding: 1.75rem 0;\n}\n.py-8{\n\tpadding: 2rem 0;\n}\n.py-9{\n\tpadding: 2.25rem 0;\n}\n.py-10{\n\tpadding: 2.5rem 0;\n}\n.py-11{\n\tpadding: 2.75rem 0;\n}\n.py-12{\n\tpadding: 3rem 0;\n}\n.py-13{\n\tpadding: 3.25rem 0;\n}\n.py-14{\n\tpadding: 3.5rem 0;\n}\n.py-15{\n\tpadding: 3.75rem 0;\n}\n.py-16{\n\tpadding: 4rem 0;\n}\n.py-17{\n\tpadding: 4.25rem 0;\n}\n.py-18{\n\tpadding: 4.5rem 0;\n}\n.py-19{\n\tpadding: 4.75rem 0;\n}\n.py-20{\n\tpadding: 5rem 0;\n}\n.py-21{\n\tpadding: 5.25rem 0;\n}\n.py-22{\n\tpadding: 5.5rem 0;\n}\n.py-23{\n\tpadding: 5.75rem 0;\n}\n.py-24{\n\tpadding: 6rem 0;\n}\n\n\n/*Padding Horizontally*/\n.px-1{\n\tpadding:0 0.25rem;\n}\n.px-2{\n\tpadding:0 0.5rem;\n}\n.px-3{\n\tpadding:0 0.75rem !important;\n}\n.px-4{\n\tpadding:0 1rem;\n}\n.px-5{\n\tpadding:0 1.25rem;\n}\n.px-6{\n\tpadding:0 1.5rem;\n}\n.px-7{\n\tpadding:0 1.75rem;\n}\n.px-8{\n\tpadding:0 2rem;\n}\n.px-9{\n\tpadding:0 2.25rem;\n}\n.px-10{\n\tpadding:0 2.5rem;\n}\n.px-11{\n\tpadding:0 2.75rem;\n}\n.px-12{\n\tpadding:0 3rem;\n}\n.px-13{\n\tpadding:0 3.25rem;\n}\n.px-14{\n\tpadding:0 3.5rem;\n}\n.px-15{\n\tpadding:0 3.75rem;\n}\n.px-16{\n\tpadding:0 4rem;\n}\n.px-17{\n\tpadding:0 4.25rem;\n}\n.px-18{\n\tpadding:0 4.5rem;\n}\n.px-19{\n\tpadding:0 4.75rem;\n}\n.px-20{\n\tpadding:0 5rem;\n}\n.px-21{\n\tpadding:0 5.25rem;\n}\n.px-22{\n\tpadding:0 5.5rem;\n}\n.px-23{\n\tpadding:0 5.75rem;\n}\n.px-24{\n\tpadding:0 6rem;\n}","@import url('https://fonts.googleapis.com/css2?family=Abel&family=Roboto:ital,wght@0,300;0,400;0,500;0,700;0,900;1,400&display=swap');\r\n@import url('https://fonts.googleapis.com/css2?family=Abel&family=Inter:wght@200;300;400;500;600;700;800&family=Roboto:ital,wght@0,300;0,400;0,500;0,700;0,900;1,400&display=swap');\r\n@import './colors';\r\n@import './spacing';\r\n\r\nbody {\r\n  background-color: $color-lightGrey !important;\r\n  font-weight: 500 !important;\r\n}\r\n.ff-inter {\r\n  font-family: 'Inter', sans-serif;\r\n}\r\n.ff-abel {\r\n  font-family: 'Abel', sans-serif;\r\n}\r\n.ff-roboto {\r\n  font-family: 'Roboto', sans-serif;\r\n}\r\na {\r\n  color: $color-monoNormalGrey !important;\r\n}\r\na:hover {\r\n  text-decoration: none !important;\r\n}\r\nh3 {\r\n  font-weight: normal;\r\n}\r\nselect {\r\n  background-repeat: no-repeat;\r\n  background-position: 96%;\r\n  -moz-appearance: none;\r\n  -webkit-appearance: none;\r\n  appearance: none;\r\n}\r\n.fs-12 {\r\n  font-size: 12px;\r\n}\r\n.fs-13 {\r\n  font-size: 12px;\r\n}\r\n.fs-14 {\r\n  font-size: 14px;\r\n}\r\n.fs-16 {\r\n  font-size: 1rem;\r\n}\r\n.fs-64 {\r\n  font-size: 4rem;\r\n}\r\nh4 {\r\n  font-weight: normal !important;\r\n}\r\n.card-title {\r\n  margin-bottom: 1rem !important;\r\n}\r\nlabel,\r\nh4 {\r\n  color: $color-monoNormalGrey;\r\n}\r\nlabel {\r\n  font-size: 14px;\r\n}\r\n\r\n/* Gaps */\r\n.gap-1 {\r\n  gap: 0.25rem !important;\r\n}\r\n.gap-2 {\r\n  gap: 0.5rem !important;\r\n}\r\n.gap-3 {\r\n  gap: 0.75rem !important;\r\n}\r\n.gap-4 {\r\n  gap: 1rem !important;\r\n}\r\n.gap-5 {\r\n  gap: 1.25rem !important;\r\n}\r\n.gap-6 {\r\n  gap: 1.5rem !important;\r\n}\r\n.gap-7 {\r\n  gap: 1.75rem !important;\r\n}\r\n.gap-8 {\r\n  gap: 2rem !important;\r\n}\r\n.gap-12 {\r\n  gap: 3rem;\r\n}\r\n.gap-16 {\r\n  gap: 4rem;\r\n}\r\n\r\n/* Border Radius */\r\n.radius-0 {\r\n  border-radius: 0rem;\r\n}\r\n.radius-1 {\r\n  border-radius: 0.25rem;\r\n}\r\n.radius-2 {\r\n  border-radius: 0.5rem;\r\n}\r\n.radius-3 {\r\n  border-radius: 0.75rem;\r\n}\r\n.radius-4 {\r\n  border-radius: 1rem;\r\n}\r\n.radius-5 {\r\n  border-radius: 1.25rem;\r\n}\r\n.radius-6 {\r\n  border-radius: 1.5rem;\r\n}\r\n.radius-7 {\r\n  border-radius: 1.75rem;\r\n}\r\n.radius-8 {\r\n  border-radius: 2rem;\r\n}\r\n.radius-9 {\r\n  border-radius: 2.25rem;\r\n}\r\n.radius-10 {\r\n  border-radius: 2.5rem;\r\n}\r\n.radius-11 {\r\n  border-radius: 2.75rem;\r\n}\r\n.radius-12 {\r\n  border-radius: 3rem;\r\n}\r\n.radius-full {\r\n  border-radius: 100%;\r\n}\r\n\r\n/*width*/\r\n.w-auto {\r\n  width: auto;\r\n}\r\n.w-screen {\r\n  width: 100vw;\r\n}\r\n\r\n.w-0 {\r\n  width: 0px;\r\n}\r\n.w-1 {\r\n  width: 0.25rem;\r\n}\r\n.w-2 {\r\n  width: 0.5rem;\r\n}\r\n.w-3 {\r\n  width: 0.5rem;\r\n}\r\n.w-4 {\r\n  width: 1rem;\r\n}\r\n.w-5 {\r\n  width: 1.25rem;\r\n}\r\n.w-6 {\r\n  width: 1.5rem;\r\n}\r\n.w-7 {\r\n  width: 1.5rem;\r\n}\r\n.w-8 {\r\n  width: 2rem;\r\n}\r\n.w-9 {\r\n  width: 2.25rem;\r\n}\r\n.w-10 {\r\n  width: 2.5rem;\r\n}\r\n.w-11 {\r\n  width: 2.5rem;\r\n}\r\n.w-12 {\r\n  width: 3rem;\r\n}\r\n.w-13 {\r\n  width: 3.25rem;\r\n}\r\n.w-14 {\r\n  width: 3.5rem;\r\n}\r\n.w-15 {\r\n  width: 3.5rem;\r\n}\r\n.w-16 {\r\n  width: 4rem;\r\n}\r\n.w-17 {\r\n  width: 4.25rem;\r\n}\r\n.w-18 {\r\n  width: 4.5rem;\r\n}\r\n.w-19 {\r\n  width: 4.5rem;\r\n}\r\n.w-20 {\r\n  width: 5rem;\r\n}\r\n.w-21 {\r\n  width: 5.25rem;\r\n}\r\n.w-22 {\r\n  width: 5.5rem;\r\n}\r\n.w-23 {\r\n  width: 5.5rem;\r\n}\r\n.w-24 {\r\n  width: 6rem;\r\n}\r\n.w-25 {\r\n  width: 7.25rem;\r\n}\r\n.w-26 {\r\n  width: 8.5rem;\r\n}\r\n.w-27 {\r\n  width: 9.5rem;\r\n}\r\n.w-28 {\r\n  width: 10rem;\r\n}\r\n\r\n.mw-20 {\r\n  max-width: 20%;\r\n}\r\n.mw-50 {\r\n  max-width: 50%;\r\n}\r\n.mw-100 {\r\n  max-width: 100%;\r\n}\r\n\r\n/* Background Colors */\r\n.bg-grey {\r\n  background-color: $color-lightGrey;\r\n}\r\n.bg-darkBlue {\r\n  background-color: $color-darkBlue;\r\n}\r\n.bg-green {\r\n  background-color: $color-green;\r\n}\r\n.bg-sharpGreen {\r\n  background-color: $color-sharpGreen;\r\n}\r\n.bg-purple {\r\n  background-color: $color-purple;\r\n}\r\n.bg-blue {\r\n  background-color: $color-blue;\r\n}\r\n\r\n/* Borders css */\r\n.border {\r\n  border: 1px solid $color-normalGrey;\r\n}\r\n.border-bottom {\r\n  border-bottom: 1px solid $color-normalGrey;\r\n}\r\n.border-top {\r\n  border-top: 1px solid $color-normalGrey;\r\n}\r\n.border-left {\r\n  border-left: 1px solid $color-normalGrey;\r\n}\r\n.border-right {\r\n  border-right: 1px solid $color-normalGrey;\r\n}\r\n.border-bottom-2 {\r\n  border-bottom: 2px solid $color-normalGrey;\r\n}\r\n.border-bottom-3 {\r\n  border-bottom: 3px solid $color-normalGrey;\r\n}\r\n\r\n.border-bottom-4 {\r\n  border-bottom: 4px solid $color-normalGrey;\r\n}\r\n\r\n/*Colors*/\r\n.color-green {\r\n  color: $color-green;\r\n}\r\n.color-pink {\r\n  color: $color-pink;\r\n}\r\n.color-monoDull {\r\n  color: $color-monoDullGrey;\r\n}\r\n.color-monoNormal {\r\n  color: $color-monoNormalGrey;\r\n}\r\n.color-monoIntense {\r\n  color: $color-monoIntenseGrey;\r\n}\r\n.color-darkBlue {\r\n  color: $color-darkBlue;\r\n}\r\n.pending {\r\n  color: $color-orange;\r\n}\r\n.inprogress {\r\n  color: $color-blue;\r\n}\r\n.complete {\r\n  color: $color-green;\r\n}\r\n.error {\r\n  color: $color-pink;\r\n}\r\n.color-greyDull {\r\n  color: rgba(79, 79, 79, 0.6);\r\n}\r\n\r\n/* Button css */\r\n.button {\r\n  color: $color-green;\r\n  padding: 10px 16px;\r\n  border-radius: 8px;\r\n  border: 2px solid $color-green;\r\n  background: transparent;\r\n  &:hover {\r\n    background: $color-secGreen;\r\n    border-color: $color-secGreen;\r\n  }\r\n}\r\n\r\n.btn-grey-border {\r\n  border-color: $color-monoDullGrey;\r\n  color: $color-monoDullGrey;\r\n  &:hover {\r\n    color: $color-white;\r\n  }\r\n}\r\n\r\n.button-with-image-and-text {\r\n  display: flex;\r\n  align-items: center;\r\n\r\n  img, svg {\r\n    margin-right: 5px;\r\n  }\r\n\r\n  svg {\r\n    path {\r\n      fill: $color-green;\r\n    }\r\n  }\r\n\r\n  &:hover svg {\r\n    path {\r\n      fill: $color-white;\r\n    }\r\n  }\r\n}\r\n\r\n.button-with-loader {\r\n  position: relative;\r\n\r\n  &-loading {\r\n    pointer-events: none;\r\n  }\r\n\r\n  &-hidden {\r\n    opacity: 0;\r\n  }\r\n\r\n  &-loader {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.btn-ghost {\r\n  &:hover {\r\n    background-color: $color-green;\r\n    color: $color-white;\r\n  }\r\n}\r\n.button-group button:first-child {\r\n  margin-right: 12px;\r\n}\r\n.btn-with-icon {\r\n  background-color: $color-green;\r\n  padding: 10px 16px 10px 12px;\r\n  color: $color-white;\r\n}\r\n.btn-with-icon.md {\r\n  padding: 4px 14px 4px 6px;\r\n  font-size: 14px;\r\n  height: 40px;\r\n}\r\n.btn-ghost.sm {\r\n  font-size: 12px;\r\n  padding: 4px 8px;\r\n  border-width: 1px;\r\n  border-radius: 4px;\r\n  font-weight: 500;\r\n}\r\n.grey-btn {\r\n  background-color: #a7b2cd;\r\n  border-color: #a7b2cd;\r\n}\r\n.ltGrey-btn {\r\n  background: $color-normalGrey;\r\n  border-color: $color-normalGrey;\r\n  color: $color-monoIntenseGrey;\r\n  &:hover {\r\n    background-color: $color-monoDullGrey;\r\n    border-color: $color-monoDullGrey;\r\n  }\r\n}\r\n\r\n/* Utilities css */\r\n.overlay-loader {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 9;\r\n  background: #f4f6fade;\r\n  display: none;\r\n  .loader {\r\n    margin-top: 3rem;\r\n  }\r\n}\r\n.overlay-loader.active {\r\n  display: block;\r\n}\r\nheader {\r\n  z-index: 999999;\r\n}\r\n.fw-normal {\r\n  font-weight: normal;\r\n}\r\n.fw-medium {\r\n  font-weight: 600 !important;\r\n}\r\n.row {\r\n  margin: 0;\r\n}\r\n.hvr-float {\r\n  -webkit-transform: perspective(1px) translateZ(0);\r\n  transform: perspective(1px) translateZ(0);\r\n  box-shadow: 0 0 1px rgb(0 0 0 / 0%);\r\n  -webkit-transition-duration: 0.2s;\r\n  transition-duration: 0.2s;\r\n  -webkit-transition-property: transform;\r\n  transition-property: transform;\r\n  -webkit-transition-timing-function: ease-out;\r\n  transition-timing-function: ease-out;\r\n  cursor: pointer;\r\n  &:hover,\r\n  &:focus,\r\n  &:active {\r\n    -webkit-transform: translateY(-4px);\r\n    -ms-transform: translateY(-4px);\r\n    transform: translateY(-4px);\r\n  }\r\n}\r\n.box-shadow:hover {\r\n  box-shadow: rgb(99 99 99 / 20%) 0px 2px 8px 0px;\r\n  transition: box-shadow 0.3s ease-in-out;\r\n}\r\n.bg-image {\r\n  background-size: cover !important;\r\n  background-position: center !important;\r\n  background-repeat: no-repeat !important;\r\n}\r\n.back-btn {\r\n  padding: 0.5rem 0.75rem;\r\n  border: 0;\r\n  border-radius: 0.5rem;\r\n  margin-right: 1rem;\r\n  background-color: $color-normalGrey;\r\n  &:hover {\r\n    background-color: $color-monoDullGrey;\r\n  }\r\n}\r\n.hvg-bg:hover {\r\n  background-color: $color-lightGrey;\r\n}\r\n.hidden {\r\n  display: none;\r\n}\r\n.show {\r\n  display: block;\r\n}\r\n.cursor-pointer {\r\n  cursor: pointer;\r\n}\r\n\r\n/* main wrapper css */\r\n.main {\r\n  overflow-x: hidden;\r\n}\r\n.wrapper {\r\n  padding-top: 70px;\r\n}\r\n.main-content {\r\n  padding-left: 240px;\r\n}\r\n.badge {\r\n  font-size: 11px !important;\r\n}\r\np.badge {\r\n  margin: 0;\r\n  width: 64px !important;\r\n  height: 20px !important;\r\n  text-align: center;\r\n  letter-spacing: -0.3px;\r\n  padding-left: 0 !important;\r\n  padding-right: 0 !important;\r\n  font-weight: 600;\r\n}\r\n.badge-color-high {\r\n  background-color: $color-orange-high;\r\n}\r\n.badge-pink {\r\n  background: $color-pink;\r\n}\r\n.badge-color-exact {\r\n  background: $color-pink;\r\n  border: 1px solid $color-pink;\r\n}\r\n.badge-color-very-high {\r\n  background-color: $color-yellow;\r\n  border: 1px solid $color-yellow;\r\n}\r\n.badge-color-medium {\r\n  background-color: $color-light-purple;\r\n  border: 1px solid $color-light-purple;\r\n}\r\n.badge-color-low {\r\n  background-color: $color-blue;\r\n  border: 1px solid $color-blue;\r\n}\r\n.badge-color-very-low {\r\n  background-color: $color-light-blue;\r\n  border: 1px solid $color-light-blue;\r\n}\r\n.badge-color-no-match {\r\n  background-color: $color-white;\r\n  border: 1px solid $color-monoDullGrey;\r\n  color: $color-monoDullGrey;\r\n}\r\n\r\np.badge.badge-risk {\r\n  width: auto !important;\r\n  height: auto !important;\r\n  padding: 0.35rem !important;\r\n}\r\n.badge-color-risk-sanctioned {\r\n  color: #E66A8B;\r\n  background-color: #FFF3F6;\r\n  border: 1px solid #FFF3F6;\r\n}\r\n.badge-color-risk-very-high {\r\n  color: #E66A8B;\r\n  background-color: #FFF3F6;\r\n  border: 1px solid #FFF3F6;\r\n}\r\n.badge-color-risk-high {\r\n  color: #AF5412;\r\n  background-color: #FEE0CB;\r\n  border: 1px solid #FEE0CB;\r\n}\r\n.badge-color-risk-medium {\r\n  color: #0090C1;\r\n  background-color: #CFEFFB;\r\n  border: 1px solid #CFEFFB;\r\n}\r\n.badge-color-risk-low {\r\n  color: #11BC97;\r\n  background-color: #E7F8F5;\r\n  border: 1px solid #E7F8F5;\r\n}\r\n.badge-color-risk-none {\r\n  background-color: #F4F6FA;\r\n  border: 1px solid #F4F6FA;\r\n  color: #626A7C;\r\n}\r\n.badge-color-risk-error-match {\r\n  color: #FFF3F6;\r\n  background-color: #E66A8B;\r\n  border: 1px solid #E66A8B;\r\n}\r\n\r\n.content-box {\r\n  padding: 2rem;\r\n}\r\n.card {\r\n  border-color: $color-normalGrey !important;\r\n  padding: 1.5rem;\r\n  border-radius: 0.5rem !important;\r\n  overflow: hidden;\r\n  input,\r\n  select {\r\n    height: 48px;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    border-radius: 0.5rem;\r\n    padding: 0.75rem 1rem;\r\n    color: $color-monoIntenseGrey !important;\r\n  }\r\n}\r\n\r\n.select-with-left-icon,\r\n.input-with-left-icon {\r\n  position: relative;\r\n}\r\n.select-with-left-icon select,\r\n.input-with-left-icon input {\r\n  padding: 0.375rem 2.25rem;\r\n}\r\n.select-with-left-icon img,\r\n.input-with-left-icon img {\r\n  position: absolute;\r\n  left: 8px;\r\n  top: 12px;\r\n}\r\n\r\n/* Pagination css */\r\n.pagination {\r\n  background: $color-white;\r\n  color: $color-monoNormalGrey;\r\n  font-size: 0.75rem;\r\n  input {\r\n    width: 80px;\r\n    text-align: center;\r\n  }\r\n  select {\r\n    width: 4rem !important;\r\n    margin-right: 0.5rem;\r\n  }\r\n}\r\n.pagination.table-listing {\r\n  width: 100%;\r\n  bottom: 0;\r\n  left: 0;\r\n  background-color: $color-white;\r\n}\r\n.pagination input,\r\n.pagination select {\r\n  border: 1px solid $color-normalGrey;\r\n  border-radius: 0.5rem;\r\n  padding: 5px 1rem;\r\n  height: 32px;\r\n}\r\n.pagination-btns button {\r\n  border: 0;\r\n  padding: 4px;\r\n  background-color: $color-green;\r\n  margin: 0 2px;\r\n  &:hover {\r\n    background: $color-secGreen;\r\n    border-color: $color-secGreen;\r\n  }\r\n}\r\n.pagination-btns button.disabled {\r\n  background-color: $color-normalGrey;\r\n}\r\n.pagination-btns button:first-child {\r\n  border-radius: 8px 0px 0px 8px;\r\n}\r\n.pagination-btns button:last-child {\r\n  border-radius: 0px 8px 8px 0px;\r\n}\r\n.card-sm {\r\n  cursor: pointer;\r\n  padding: 1rem;\r\n  width: 150px;\r\n  flex-basis: 150px;\r\n  flex-grow: 1;\r\n}\r\n.card-sm h5 {\r\n  font-size: 1rem;\r\n  margin: 0;\r\n  font-weight: normal;\r\n  line-height: 1.5rem;\r\n}\r\n.card-sm h4.opacity-0 {\r\n  opacity: 0;\r\n}\r\n.card-sm.active {\r\n  &.exact {\r\n    border-top: 4px solid $color-pink !important;\r\n  }\r\n  &.very-high {\r\n    border-top: 4px solid $color-yellow !important;\r\n  }\r\n  &.high {\r\n    border-top: 4px solid $color-orange-high !important;\r\n  }\r\n  &.medium {\r\n    border-top: 4px solid $color-light-purple !important;\r\n  }\r\n  &.low {\r\n    border-top: 4px solid $color-blue !important;\r\n  }\r\n  &.very-low {\r\n    border-top: 4px solid $color-light-blue !important;\r\n  }\r\n}\r\n.card-sm.active h4 {\r\n  color: $color-darkBlue;\r\n}\r\n\r\n.card.top-head {\r\n  border-radius: 0 0 8px 8px !important;\r\n}\r\n.ew-cols > div {\r\n  width: 150px;\r\n  flex-basis: 150px;\r\n  flex-grow: 1;\r\n}\r\n.dynamic-countries {\r\n  font-size: 14px;\r\n  .css-1okebmr-indicatorSeparator {\r\n    display: none;\r\n  }\r\n  input {\r\n    height: 34px;\r\n  }\r\n  svg {\r\n    transform: rotate(0deg) !important;\r\n    path {\r\n      //fill: $color-monoDullGrey;\r\n      fill: #80889c;\r\n    }\r\n  }\r\n  .css-1s2u09g-control {\r\n    border-radius: 0.5rem !important;\r\n  }\r\n  .css-1pahdxg-control {\r\n    border-color: #80bdff !important;\r\n    outline: 0;\r\n    box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%) !important;\r\n  }\r\n}\r\n\r\n::placeholder {\r\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\r\n  color: $color-monoNormalGrey !important;\r\n  opacity: 0.4 !important; /* Firefox */\r\n}\r\n:-ms-input-placeholder {\r\n  /* Internet Explorer 10-11 */\r\n  color: $color-monoNormalGrey !important;\r\n}\r\n::-ms-input-placeholder {\r\n  /* Microsoft Edge */\r\n  color: $color-monoNormalGrey !important;\r\n}\r\n/* .result-list .heading span{\r\n\tposition: sticky;\r\n    top: 0;\r\n    background-color: $color-white;\r\n} */\r\n.overflow-visible {\r\n  overflow: visible;\r\n}\r\n.ew-cols .button-group {\r\n  width: auto;\r\n  flex-basis: auto;\r\n  flex-grow: inherit;\r\n}\r\n\r\n.custom-checkbox {\r\n  display: block;\r\n  margin-bottom: 15px;\r\n}\r\n.custom-checkbox input {\r\n  padding: 0;\r\n  height: initial;\r\n  width: initial;\r\n  margin-bottom: 0;\r\n  display: none;\r\n  cursor: pointer;\r\n}\r\n.custom-checkbox label {\r\n  position: relative;\r\n  cursor: pointer;\r\n  color: #11bc97;\r\n  font-size: 16px;\r\n  margin-left: 3px;\r\n}\r\n.custom-checkbox label:before {\r\n  content: '';\r\n  -webkit-appearance: none;\r\n  background-color: transparent;\r\n  border: 2px solid #11bc97;\r\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);\r\n  padding: 10px;\r\n  display: inline-block;\r\n  position: relative;\r\n  vertical-align: middle;\r\n  cursor: pointer;\r\n  margin-right: 8px;\r\n  border-radius: 4px;\r\n}\r\n.custom-checkbox input:checked + label:after {\r\n  content: '';\r\n  display: block;\r\n  position: absolute;\r\n  top: 4px;\r\n  left: 9px;\r\n  width: 6px;\r\n  height: 14px;\r\n  border: solid #11bc97;\r\n  border-width: 0 2px 2px 0;\r\n  transform: rotate(45deg);\r\n}\r\n\r\n@media only screen and (min-width: 1300px) and (max-width: 1800px) {\r\n  body {\r\n    /* webkit browsers */\r\n    zoom: 85%;\r\n    /* moz browsers , since there is no support to \"zoom\" */\r\n  }\r\n}\r\n","$color-white: #ffffff;\n$color-black: #000000;\n$color-green:#11BC97;\n$color-secGreen:#0ead8a;\n$color-blue:#2091E9;\n$color-sharpGreen:#01FFCA;\n$color-pink:#E66A8B;\n$color-orange:#FB8C3D;\n$color-orange-high:#F4B717;\n$color-yellow:#FB8C3D;\n$color-purple:#A001FF;\n$color-light-purple:#7879F1;\n$color-darkBlue:#110133;\n$color-lightGrey:#F4F6FA;\n$color-normalGrey:#E4E7F0;\n$color-monoDullGrey:#A7B2CD;\n$color-monoNormalGrey:#636A7D;\n$color-light-blue:#a7b2cd;\n$color-monoIntenseGrey:#222735;\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
